/**
 * @generated SignedSource<<751c85296ff7e8ec8c50b0a2120608ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WelcomeChecklistTaskCompletionStatus = "COMPLETE" | "INCOMPLETE" | "PENDING_COMPLETION";
export type WelcomeChecklistTaskKey = "DESKTOP_APP_INSTALLED" | "EXTENSION_INSTALLED" | "FIRST_AGENDA_PREPARED" | "REVIEW_FIRST_RECAP";
export type Tours_CompleteWelcomeChecklistTourMutation$variables = {
  taskKey: WelcomeChecklistTaskKey;
};
export type Tours_CompleteWelcomeChecklistTourMutation$data = {
  readonly completeWelcomeChecklistTour: {
    readonly viewer: {
      readonly id: string;
      readonly welcomeChecklist: {
        readonly desktopAppInstalled: WelcomeChecklistTaskCompletionStatus;
        readonly extensionInstalled: WelcomeChecklistTaskCompletionStatus;
        readonly firstAgendaPrepared: WelcomeChecklistTaskCompletionStatus;
        readonly reviewFirstRecap: WelcomeChecklistTaskCompletionStatus;
        readonly showReviewFirstRecap: boolean;
      };
    };
  } | null;
};
export type Tours_CompleteWelcomeChecklistTourMutation = {
  response: Tours_CompleteWelcomeChecklistTourMutation$data;
  variables: Tours_CompleteWelcomeChecklistTourMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskKey"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskKey",
        "variableName": "taskKey"
      }
    ],
    "concreteType": "CompleteWelcomeChecklistTour",
    "kind": "LinkedField",
    "name": "completeWelcomeChecklistTour",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WelcomeChecklist",
            "kind": "LinkedField",
            "name": "welcomeChecklist",
            "plural": false,
            "selections": [
              {
                "alias": "firstAgendaPrepared",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "FIRST_AGENDA_PREPARED"
                  }
                ],
                "kind": "ScalarField",
                "name": "task",
                "storageKey": "task(key:\"FIRST_AGENDA_PREPARED\")"
              },
              {
                "alias": "extensionInstalled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "EXTENSION_INSTALLED"
                  }
                ],
                "kind": "ScalarField",
                "name": "task",
                "storageKey": "task(key:\"EXTENSION_INSTALLED\")"
              },
              {
                "alias": "desktopAppInstalled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "DESKTOP_APP_INSTALLED"
                  }
                ],
                "kind": "ScalarField",
                "name": "task",
                "storageKey": "task(key:\"DESKTOP_APP_INSTALLED\")"
              },
              {
                "alias": "reviewFirstRecap",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "REVIEW_FIRST_RECAP"
                  }
                ],
                "kind": "ScalarField",
                "name": "task",
                "storageKey": "task(key:\"REVIEW_FIRST_RECAP\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showReviewFirstRecap",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Tours_CompleteWelcomeChecklistTourMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Tours_CompleteWelcomeChecklistTourMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46f4fe8cddc5f8aedd133e82409f5023",
    "id": null,
    "metadata": {},
    "name": "Tours_CompleteWelcomeChecklistTourMutation",
    "operationKind": "mutation",
    "text": "mutation Tours_CompleteWelcomeChecklistTourMutation(\n  $taskKey: WelcomeChecklistTaskKey!\n) {\n  completeWelcomeChecklistTour(taskKey: $taskKey) {\n    viewer {\n      id\n      welcomeChecklist {\n        firstAgendaPrepared: task(key: FIRST_AGENDA_PREPARED)\n        extensionInstalled: task(key: EXTENSION_INSTALLED)\n        desktopAppInstalled: task(key: DESKTOP_APP_INSTALLED)\n        reviewFirstRecap: task(key: REVIEW_FIRST_RECAP)\n        showReviewFirstRecap\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7038e9b7a7efe2c7c9384942cab8633";

export default node;
